import { Component, OnInit } from '@angular/core';

import { TeamService } from '../shared/team.service';
import { TestTeamSeason } from '../shared/models/test.model';

import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTable, MatTableDataSource, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatCard, MatCardHeader, MatCardAvatar, MatCardTitle } from '@angular/material/card';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-team-season-list',
    templateUrl: './team-season-list.component.html',
    styleUrls: ['./team-season-list.component.css'],
    imports: [MatCard, MatCardHeader, MatCardAvatar, MatCardTitle, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatIconButton, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator]
})
export class TeamSeasonListComponent implements OnInit {

  _seasons: TestTeamSeason[];
  dataSource: MatTableDataSource<TestTeamSeason>;
  displayedColumns: string[] = ['Name', 'LevelName', 'SeasonId','NoOfPlayers','Actions'];

  constructor(private _teamService: TeamService) { }

  ngOnInit() {

    this.getSeasons();

  }

  getSeasons(){

    this._teamService.getTeamSeasons().subscribe((results: TestTeamSeason[]) =>{
      this._seasons = results;
      this.dataSource = new MatTableDataSource<TestTeamSeason>(results);
    });
  }



}
